export default __webpack_public_path__ + "static/media/lights.88644319.png";